import React, { createContext, useContext, useState } from 'react';

type PromptContextType = {
  title:string,
  message: string | null,
  promptType:string,
  initPrompt: (title:string,message: string | null,callbackFunc?:()=>void) => void,
  logoutPrompt:(title:string,message: string | null,callbackFunc?:()=>void) => void,
  closePrompt:()=> void,
  isPromptOpen:boolean,
  callbackFunc?:()=>void
};

type ChildrenType = {
  children: React.ReactNode;
};

type PromptState={
    title: string;
    message: string | null;
    isPromptOpen: boolean;
    promptType:string,
    callbackFunc?: () => void;
}


const PromptContext = createContext<PromptContextType | undefined>(undefined);

export const PromptProvider = ({ children }:ChildrenType) => {

  const [prompt, setPrompt] = useState<PromptState>({
    isPromptOpen:false,
    title:'',
    message:null,
    promptType:''
  });

  const closePrompt=()=>{
    setPrompt((prev)=>{
        return {
            ...prev,
            isPromptOpen:false,
            callbackFunc:()=>{},
            message:''
        }
    })
  }

  const initPrompt=(title:string,message:string | null,callbackFunc?:()=>void)=>{
   
    setPrompt((prev)=>{
        return {
            ...prev,
            title:title,
            message:message,
            isPromptOpen:true,
            promptType:'default',
            callbackFunc:callbackFunc
        }
    })

  }

  const logoutPrompt=(title:string,message:string | null,callbackFunc?:()=>void)=>{
    setPrompt((prev)=>{
      return {
          ...prev,
          title:title,
          message:message,
          isPromptOpen:true,
          promptType:'logout',
          callbackFunc:callbackFunc
      }
  })
  }


  let st:PromptContextType={
    title:prompt.title,
    message:prompt.message,
    initPrompt,
    logoutPrompt,
    closePrompt,
    isPromptOpen:prompt.isPromptOpen,
    callbackFunc:prompt.callbackFunc,
    promptType:prompt.promptType
  }

  return (
    <PromptContext.Provider value={st}>
      {children}
    </PromptContext.Provider>
  );
};

export const usePrompt = (): PromptContextType => {
  const context = useContext(PromptContext);
  if (!context) {
    throw new Error('usePrompt must be used within a PromptProvider');
  }
  return context;
};
